import React from "react";

import { boundError } from "../../utils";

const ProfilePageRaw = ({ children }) => {
  return <div style={{ backgroundColor: "white", borderRadius: 20, padding: 30, width: "100%", marginBottom: 60}}>{children}</div>;
};

export const ProfilePage = boundError(ProfilePageRaw);
